import Swiper from "swiper";
import 'swiper/css/bundle';

import SwiperCore, {
    EffectCoverflow,
    Scrollbar,
    Autoplay,
    Navigation,
    Pagination,
} from "swiper/core";

SwiperCore.use([EffectCoverflow, Scrollbar, Autoplay, Navigation, Pagination]);

export default function initUsefulLinks() {
    new Swiper(".useful .swiper", {
        speed: 500,
        grabCursor: true,
        spaceBetween: 30,
        autoplay: true,
        loop: true,
        navigation: {
            nextEl: ".useful .swiper-button-next",
            prevEl: ".useful .swiper-button-prev",
        },
        breakpoints: {
            1400: {
                slidesPerView: 5,
                slidesPerGroup: 1
            },
            992: {
                slidesPerView: 4,
                slidesPerGroup: 1
            },
            768: {
                slidesPerView: 3,
                slidesPerGroup: 3
            },

            560: {
                slidesPerView: 2,
                slidesPerGroup: 2
            },
        }
    });
}